<div
  class="form-control"
  [ngClass]="{ focus: focused, 'is-invalid': errorState, disabled: disabled }"
  (click)="onContainerClick()"
>
  <div
    style="margin-left: -10px"
    role="group"
    [formGroup]="parts"
    (focusin)="onFocusIn($event)"
    (focusout)="onFocusOut($event)"
  >
    <input
      class="time-field-input-element text-right"
      placeholder="--"
      formControlName="hour"
      maxLength="2"
      size="1"
      aria-label="Hour"
      (input)="handleInput(parts.controls.hour, minute)"
      #hour
    />
    <span>&colon;</span>
    <input
      class="time-field-input-element"
      placeholder="--"
      formControlName="minute"
      maxLength="2"
      size="1"
      aria-label="Minute"
      (input)="handleInput(parts.controls.minute, ampm)"
      (keyup.backspace)="autoFocusPrev(parts.controls.minute, hour)"
      #minute
    />
    <input
      class="time-field-input-element"
      placeholder="--"
      formControlName="ampm"
      maxLength="2"
      size="1"
      aria-label="AmPm"
      (input)="handleInput(parts.controls.ampm)"
      (keyup.backspace)="autoFocusPrev(parts.controls.ampm, minute)"
      #ampm
    />
    <span class="icon-wrapper">
      <i placement="right" class="modus-icons modus-icon-sm">clock</i>
    </span>
  </div>
</div>
